// Dynamically imports box-typescript-sdk-gen so the ~1.7MB SDK is code-split into
// an async chunk instead of shipping in the initial JS of every route with a Box
// upload/download surface (client-detail, tasks, onboarding, welcome, and more).
// Keep this a dynamic import: a static `import { BoxClient }` re-bloats all of them.
export async function createBoxClient(token: string) {
  const { BoxClient, BoxDeveloperTokenAuth } = await import('box-typescript-sdk-gen');
  return new BoxClient({ auth: new BoxDeveloperTokenAuth({ token }) });
}
